module.exports = "<div class=\"info-wrapper\" (click)=\"saveInstruction()\">\r\n    <i class=\"fa info-component\" [className]=\"'fa info-component ' + ico\" [ngStyle]=\"{'color': color}\" data-toggle=\"tooltip\" [attr.data-placement]=\"direction\" [attr.title]=\"inputData\"></i>\r\n</div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/component-info.component/component-info.component.html
// module id = ./src/app/shared/components/component-info.component/component-info.component.html
// module chunks = main